







































































import Vue from 'vue';
import Component from 'vue-class-component';
import { AuthenticationModuleState } from '../types';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState<AuthenticationModuleState>('authenticationModule', {
      localUser: (state: AuthenticationModuleState) => state.localUser
    })
  }
})
export default class HelloWorld extends Vue {}
